// De prijs onder het product, met de aantalkiezer ernaast.
//
// In het Shopify-thema geeft de pagina twee dingen mee: de prijs en het variant-id
// uit de winkel zelf. Dan kan wat hier staat niet uit de pas lopen met wat de kassa
// rekent. Staan ze er niet — de losse map, buiten Shopify — dan valt hij terug op
// de waarden hieronder en gaat de knop nergens heen.
document.addEventListener('DOMContentLoaded', () => {
  const blok = document.querySelector('.cadans_koop');
  if (!blok) return;

  const PRIJS_CENT = Number(window.CADANS_PRIJS_CENT) || 13999;
  const VARIANT = window.CADANS_VARIANT || null;
  const MAX = 9;

  const prijs = blok.querySelector('.cadans_koop-prijs');
  const waarde = blok.querySelector('.cadans_aantal-waarde');
  const knop = blok.querySelector('.cadans_koop-knop');
  const knoppen = Array.from(blok.querySelectorAll('.cadans_aantal-knop'));
  if (!prijs || !waarde || !knoppen.length) return;

  let aantal = 1;

  const toon = () => {
    waarde.textContent = aantal;
    // in centen rekenen, anders levert 3 × 139,99 een cent verschil op
    prijs.textContent = '€ ' + ((PRIJS_CENT * aantal) / 100).toFixed(2).replace('.', ',');
    knoppen.forEach((k) => {
      const volgend = aantal + Number(k.dataset.stap);
      k.disabled = volgend < 1 || volgend > MAX;
    });
    if (knop && VARIANT) knop.href = `/cart/${VARIANT}:${aantal}`;
  };

  knoppen.forEach((k) => {
    k.addEventListener('click', () => {
      aantal = Math.min(MAX, Math.max(1, aantal + Number(k.dataset.stap)));
      toon();
    });
  });

  toon();
});
